// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmationModal_modal__iCUFF","modalMain":"ConfirmationModal_modalMain__CEv0-","visible":"ConfirmationModal_visible__KYNWZ"};